import { styled as muiStyled } from "@mui/material/styles";
import MuiCheckbox from "@mui/material/Checkbox";

const Checkbox = muiStyled(MuiCheckbox, {
  shouldForwardProp: (prop) => prop !== "sx",
})(() => ({
  padding: 8,
  color: "var(--lightgrey-color)",
  "&.Mui-checked": {
    color: "var(--primary-color)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 24,
  },
}));

export default Checkbox;
